const OnboardingCategoriesQueryKeys = {
  global: ["onboardingCategories"] as const,
  list: () => [...OnboardingCategoriesQueryKeys.global, "list"] as const,
};

export { OnboardingCategoriesQueryKeys };
